module.exports = __webpack_public_path__ + "assets/googleplay_bt.1ff7c06f.svg";